import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import { LcsNativeDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/native-date-time-adapter';

@Component({
    providers: [{ provide: LcsDateTimeAdapter, useClass: LcsNativeDateTimeAdapter }],
    selector: 'ndt-report',
    styleUrls: ['./report.component.scss'],
    templateUrl: 'report.component.html',
    standalone: false
})
export class ReportComponent {
   @Input() callState: CallState;

   @Input() name: string;

   @Input() pageType = 'Reports';

   @Input() showReportOutput: boolean;

   @Input() showNoReportDataFound: boolean;

   @Input() allowExcel: boolean;

   @Input() allowHtml: boolean;

   @Input() allowPdf: boolean;

   @Input() allowMemorize: boolean;

   @Output() configure = new EventEmitter<void>();

   @Output() downloadExcel = new EventEmitter<void>();

   @Output() downloadHtml = new EventEmitter<void>();

   @Output() downloadPdf = new EventEmitter<void>();

   @Output() saveParameters = new EventEmitter<void>();

   onConfigure(): void {
      this.configure.emit();
   }

   onDownloadExcel(): void {
      this.downloadExcel.emit();
   }

   onDownloadHtml(): void {
      this.downloadHtml.emit();
   }

   onDownloadPdf(): void {
      this.downloadPdf.emit();
   }

   onSaveParameters(): void {
      this.saveParameters.emit();
   }
}
